import request from '@/utils/request'
const apiPath = '/temp/templateClassificationAuth'
import { downloadBlob, getFileNameFromContentDisposition } from '@/utils/download'
const templateClassificationAuthApi = {
  /**
   * 新增【模版分类】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【模版分类】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【模版分类】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【模版分类】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【模版分类】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【模版分类】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  downloadExcelTemplate(query) {
    return request.get(`${apiPath}/downloadExcelTemplate`, { responseType: 'blob', params: query })
      .then(res => {
        console.log('下载响应:', res)
        console.log('响应数据类型:', res.data)
        console.log('res.data类型:', typeof res.data)
        console.log('是否Blob:', res.data instanceof Blob)
        console.log('响应头:', res.headers)
        
        // blob 响应时会跳过拦截器，直接返回 response 对象
        // 检查响应状态
        if (res.status < 200 || res.status >= 300) {
          throw new Error(`下载失败，状态码: ${res.status}`)
        }
        
        // 确保 res.data 是 Blob 对象
        if (!(res.data instanceof Blob)) {
          console.error('响应数据不是 Blob 对象:', res.data)
          throw new Error('响应数据格式错误')
        }
        
        // 检查响应数据类型，如果是 JSON，说明可能是错误信息
        if (res.data.type && res.data.type.indexOf('application/json') !== -1) {
          return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => {
              try {
                const jsonData = JSON.parse(reader.result)
                reject(new Error(jsonData.message || '下载失败'))
              } catch (e) {
                reject(new Error('下载失败'))
              }
            }
            reader.onerror = () => {
              reject(new Error('读取响应数据失败'))
            }
            reader.readAsText(res.data)
          })
        }
        
        // 从响应头中提取文件名
        const contentDisposition = res.headers['content-disposition'] || res.headers['Content-Disposition']
        let fileName = '下载模板.xlsx' // 默认文件名
        
        if (contentDisposition) {
          const extractedFileName = getFileNameFromContentDisposition(contentDisposition)
          if (extractedFileName) {
            fileName = extractedFileName
          }
        }
        
        console.log('提取的文件名:', fileName)
        
        // 正常的 Blob 响应，直接下载
        downloadBlob(res.data, fileName)
      })
      .catch(error => {
        console.error('下载模板失败:', error)
        throw error
      })
  },
  importExcel(data) {
    return request.post(apiPath + '/importExcel', data)
  },
}
export default templateClassificationAuthApi
